import { usePremiumRecalcStore } from "@/src/stores/usePremiumRecalcStore";
import { apiCallsModalStore } from "@/src/components/pages/StepPage/components/apiCalls/modalStore";
import { ApiCallModalType } from "@/src/components/pages/StepPage/components/apiCalls/types";
import { scrollToTop } from "@/src/components/Action/useNavigation";

export function documentsApprove(
    isValid: boolean,
    datesValid: boolean,
    prevProcessInstance: string | null,
    processInstanceQueryParams: null | string,
    method: any){
    if (!isValid || !datesValid) {
        scrollToTop(true);
        return;
    }
    if (prevProcessInstance === processInstanceQueryParams) {
        const recalcData = usePremiumRecalcStore.getState().recalcData;

        if (recalcData) {
            apiCallsModalStore.getState().open(ApiCallModalType.AGREEMENT, {
                warnText: recalcData.warnText,
                description: recalcData.description,
                defaultValues: recalcData.defaultValues,
            });
            usePremiumRecalcStore.getState().clearRecalcData();
        } else {
            apiCallsModalStore.getState().open(ApiCallModalType.AGREEMENT, {
                description: method.additionalParams.description,
            });
        }
    }
}